import { useLazyQuery, useMutation } from '@apollo/client/react';
import {
  STAFF_SALES_LOOKUP,
  STAFF_SALES_EXTEND_TRIAL,
  STAFF_SALES_RESET_FREE_TRIAL,
  STAFF_SALES_UPLIFT_ENGAGE,
  STAFF_SALES_SET_SCREENS_LIMIT,
} from '@staff-app/graphql-client';

/** Echo of the affected customer, returned by every sales-console mutation. */
export interface SalesActionResult {
  accountId: string;
  companyName?: string | null;
  message: string;
}

/** Read-only current state for the preview, resolved by Stripe ID. */
export interface SalesLookupResult {
  accountId: string;
  companyName?: string | null;
  plan?: string | null;
  planFeature?: string | null;
  isTrial: boolean;
  trialEndDate?: string | null;
  maxQuantity?: number | null;
}

/** Lazy lookup — always hits the network so the preview reflects live state. */
export function useSalesLookup() {
  return useLazyQuery<{ staffSalesLookup: SalesLookupResult }, { stripeId: string }>(
    STAFF_SALES_LOOKUP,
    { fetchPolicy: 'network-only' },
  );
}

type TrialVars = { stripeId: string; trialEndDate: string };
type ScreensVars = { stripeId: string; maxQuantity: number };

export function useSalesExtendTrial() {
  return useMutation<{ staffSalesExtendTrial: SalesActionResult }, TrialVars>(
    STAFF_SALES_EXTEND_TRIAL,
  );
}

export function useSalesResetToFreeTrial() {
  return useMutation<{ staffSalesResetToFreeTrial: SalesActionResult }, TrialVars>(
    STAFF_SALES_RESET_FREE_TRIAL,
  );
}

export function useSalesUpliftToEngage() {
  return useMutation<{ staffSalesUpliftToEngage: SalesActionResult }, TrialVars>(
    STAFF_SALES_UPLIFT_ENGAGE,
  );
}

export function useSalesSetScreensLimit() {
  return useMutation<{ staffSalesSetScreensLimit: SalesActionResult }, ScreensVars>(
    STAFF_SALES_SET_SCREENS_LIMIT,
  );
}
